import React from 'react';

// Components
import {
  Color,
  FontType,
  Typography,
  Box,
  Element
} from '@americanexpress/aqx-components';
import styles from '../__styles__/index.scss?modules';

export const StackedTile = ({ content }) => {
  const { top, bottom } = content;
  return (
    <Box
      $border
      className={styles.stackedBenefitTilesWrapper}
      theme={{ marginBottom: '20px', marginTop: '20px' }}
    >
      <Element className={styles.rowContainer}>
        <Element className={styles.imgcolumnWrapper}>
          <Element
            Component="img"
            src={top?.assets?.desktop?.src}
            alt={top?.assets?.desktop?.alt || ''}
          />
        </Element>
        <Element className={styles.columnWrapper}>
          <Element
            theme={{
              marginLeft: 20,
              paddingTop: 20,
              marginRight: 40,
              marginBottom: 10
            }}
          >
            {top?.assets?.logo && (
              <Element
                Component="img"
                className={styles.logoImg}
                theme={{ paddingTop: 5 }}
                src={top?.assets?.logo?.src}
                alt={top?.assets?.logo?.alt || ''}
              />
            )}
            {top?.title && (
              <Typography
                className={styles.title}
                Component="h3"
                $family={FontType.BentonBold}
                $size="20px"
                $lineHeight="28px"
                theme={{ color: Color.DeepBlue, marginBottom: 5 }}
              >
                {top?.title}
              </Typography>
            )}
            {top?.description && (
              <Typography
                Component={'p'}
                $family={FontType.HelveticaRegular}
                $size="15px"
                $lineHeight="24px"
                theme={{ color: Color.Gray06 }}
              >
                {top.description}
              </Typography>
            )}
          </Element>
        </Element>
      </Element>
      <Element className={styles.rowContainer}>
        <Element className={styles.columnWrapper}>
          <Element
            theme={{
              padding: 10,
              marginLeft: 20,
              marginTop: 10,
              marginRight: 20,
              marginBottom: 30
            }}
          >
            {bottom?.assets?.logo && (
              <Element
                Component="img"
                className={styles.logoImg}
                src={bottom?.assets?.logo?.src}
                alt={bottom?.assets?.logo?.alt || ''}
              />
            )}
            <Typography
              className={styles.title}
              Component="h3"
              $family={FontType.BentonBold}
              $size="20px"
              $lineHeight="28px"
              theme={{ color: Color.DeepBlue, marginBottom: 5 }}
            >
              {bottom?.title}
            </Typography>
            <Typography
              Component={'p'}
              $family={FontType.HelveticaRegular}
              $size="15px"
              $lineHeight="24px"
              theme={{ color: Color.Gray06 }}
            >
              {bottom && bottom?.description}
            </Typography>
          </Element>
        </Element>
        <Element className={styles.imgcolumnWrapper}>
          <Element
            Component="img"
            src={bottom?.assets?.desktop?.src}
            alt={bottom?.assets?.logo?.alt || ''}
          />
        </Element>
      </Element>
    </Box>
  );
};

export default React.memo(StackedTile);
